import { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import Logo from "assets/logo/logo_morning.png";
// import Print from "assets/morning/Print.png";
// import Print from "assets/morning/Print-v2.png";
import Print from "assets/morning/Print-v3.png";
import { QRCodeSVG } from "qrcode.react";
import loadImage from "../../../../assets/common/common/call.png";

interface Props {
    data: any;
    onClose: () => void;
}

const PrintA4 = ({ data, onClose }: Props) => {
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const printedRef = useRef(false);

    const validData = data.filter((item: any) => Object.keys(item).length > 0);
    const totalImages = validData.length;
    const loadedCountRef = useRef(0);

    const handleImageLoad = () => {
        loadedCountRef.current += 1;
        if (loadedCountRef.current === totalImages && !printedRef.current) {
            printedRef.current = true;
            setImagesLoaded(true);
        }
    };

    useEffect(() => {
        if (imagesLoaded) {
            const handleAfterPrint = () => {
                onClose();
                window.removeEventListener("afterprint", handleAfterPrint);
            };

            window.addEventListener("afterprint", handleAfterPrint);

            setTimeout(() => {
                window.print();
            }, 200);
        }
    }, [imagesLoaded, data]);

    return ReactDOM.createPortal(
        <div id="print-a4" className="print-a4 pl-0.5">
            {data.map((item: any, index: any) => {
                const isEmpty = Object.keys(item).length === 0;
                const isSendManager = item?.보내는담당자;
                const isSendPhoneNoManager = !isSendManager && item?.보내는핸드폰번호;

                return (
                    <div key={index}>
                        {isEmpty ? (
                            <div className="w-full h-[330px] mb-7 flex items-center justify-center text-gray-400 text-sm" />
                        ) : (
                            <div className="relative h-[330px] w-auto mb-7 rounded-xl overflow-hidden">
                                <div className="grid w-full h-[330px]">
                                    <img src={Print} alt="배경" className="w-full h-[330px] object-cover row-start-1 col-start-1" />
                                    <div className="z-10 row-start-1 h-[325px] col-start-1 px-5 py-3 flex">
                                        <div className="flex flex-col w-[38%] min-w-[38%] max-w-[38%] overflow-hidden">
                                            <div className="pr-7 px-2 pt-0.5 pb-3.5">
                                                <img className="w-[210px]" src={Logo} alt="Logo" />
                                                <p className="text-[7px] text-[#666]">www.morning.ilshingroup.com</p>
                                            </div>
                                            <p className="text-[18px] pr-7 font-bold pb-1">
                                                <span className="text-[15px] text-[#333D5C] font-normal min-w-[80px] inline-block"></span>
                                                <span className="min-h-[16px] inline-block">
                                                    {item?.접수일자 ? item.접수일자 : <>&nbsp;</>}
                                                </span>
                                            </p>
                                            <p className="text-[18px] pr-7 font-bold pt-0.5 pb-3 whitespace-nowrap">
                                                <span className="text-[15px] text-[#333D5C] font-normal min-w-[80px] inline-block"></span>
                                                <span>{item.B_L번호}</span>
                                            </p>
                                            <p className="text-[18px] font-bold py-1.5">
                                                <span className="text-[15px] text-[#333D5C] font-normal min-w-[80px] inline-block"></span>
                                                <span>1566-0685</span>
                                            </p>
                                            <div className="flex">
                                                <div className="p-2 flex flex-col w-[40%] min-w-[40%] max-w-[40%]">
                                                    <p className="mt-[-2px] ml-[14px] self-end pr-[10px]">{item.담당자명 ?? "-"}</p>

                                                    <QRCodeSVG value={item.B_L번호} width={66} height={66} className="mt-3 mr-5 shrink-0" />

                                                    <img src={loadImage} alt="" onLoad={handleImageLoad} className="w-0 h-0 absolute" />
                                                    <img src={loadImage} alt="" onLoad={handleImageLoad} className="w-0 h-0 absolute" />

                                                    {/* <img
                                                        onLoad={handleImageLoad}
                                                        onError={handleImageLoad}
                                                        loading="eager"
                                                        className="mt-3 mr-5 shrink-0"
                                                        src={item.QR66x66 || ""}
                                                        alt="QR66x66"
                                                        width={66}
                                                        height={66}
                                                    /> */}
                                                </div>
                                                <div className="p-2 w-[60%] min-w-[60%] max-w-[60%]">
                                                    <p className="mt-[15px] break-keep whitespace-wrap">{item.요청사항}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-col w-full pl-1">
                                            <div className="flex">
                                                <div className="flex flex-col w-full">
                                                    <div className="flex -mt-2">
                                                        <p className="h-[65px] font-bold text-5xl flex items-center justify-center">
                                                            {item?.센터코드}
                                                        </p>
                                                        <p className="h-[65px] min-w-60 ml-8 font-bold text-3xl flex items-center">
                                                            {item?.센터명}
                                                        </p>
                                                        <div className="-mt-1 ml-2 -mb-10">
                                                            <QRCodeSVG
                                                                value={item.B_L번호}
                                                                width={66}
                                                                height={66}
                                                                className="mt-7 shrink-0"
                                                            />

                                                            {/* <img
                                                                onLoad={handleImageLoad}
                                                                onError={handleImageLoad}
                                                                loading="eager"
                                                                className="mt-7 mr-5 shrink-0"
                                                                src={item.QR66x66 || ""}
                                                                alt="QR66x66"
                                                                width={66}
                                                                height={66}
                                                            /> */}
                                                        </div>
                                                    </div>
                                                    <div className="flex h-11 mt-1">
                                                        <div className="flex h-11">
                                                            <p className="w-40 pl-4 flex items-center font-bold">{item?.운임}</p>
                                                        </div>
                                                        <div className="flex">
                                                            <p className="ml-7 flex items-center font-bold ">{item?.수량}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex ml-1">
                                                <div className="flex flex-col mt-2 justify-center pl-3 min-h-[64px]">
                                                    <p className="font-bold leading-[16px] overflow-hidden">
                                                        {item?.보내는상호} {item?.보내는전화번호}
                                                    </p>
                                                    <p className="text-[13px] tracking-[0.8] leading-[14px] mt-[2px]">
                                                        {item?.보내는주소1} {item?.보내는주소2}{" "}
                                                        {item?.보내는담당자 && `/ 담당자 ${item.보내는담당자}`}
                                                        {isSendPhoneNoManager && "/ "} {item?.보내는핸드폰번호}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex mt-3 ml-1">
                                                <div className="font-bold w-full rounded-br-xl flex flex-col pl-3 justify-center">
                                                    <p className="text-xl">{item?.받는상호}</p>
                                                    <p className="">{item?.받는전화번호}</p>
                                                    <p>
                                                        {item?.받는주소1}
                                                        {item?.받는주소2}
                                                    </p>
                                                    <p>
                                                        {item?.받는담당자 && `담당자 ${item?.받는담당자}`}
                                                        {item?.받는담당자 && item?.받는핸드폰번호 && "/ "}
                                                        {item?.받는핸드폰번호}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>,
        document.body,
    );
};
export default PrintA4;
